import { Button } from '@givebutter/primitives/button';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as AddEvent from 'assets/js/pages/contacts/single/timeline/add-event';
import { ActivityItemDropdown } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/components/ActivityItemDropdown';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { hasEmailContent } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/helpers';
import * as DeleteItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/manual/DeleteItem';
import { getConfigs } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/manual/helpers';
import { Contact, ManualItemActivity } from 'types/domain';

interface ManualItemActivityProps {
    item: ManualItemActivity;
    contact: Contact;
}

const ManualItem = ({ item, contact }: ManualItemActivityProps) => {
    const { note, subject } = item.data;
    const configs = getConfigs(item, contact);

    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger disabled={!hasEmailContent(item.data)}>
                <div className="flex flex-grow items-center gap-4">
                    <ActivityItem.Icon className="bg-gray-200">
                        <FontAwesomeIcon icon={configs.icon} />
                    </ActivityItem.Icon>
                    {configs.text}
                </div>
                <ActivityItemDropdown activity={item} />
            </ActivityItem.Trigger>
            <ActivityItem.Content className="flex flex-col gap-3">
                <p className="font-medium">{subject ?? 'Note'}</p>
                {note && (
                    <p className="max-w-[34.625rem] overflow-x-auto whitespace-pre-wrap">{note}</p>
                )}
                <div className="flex justify-end gap-3">
                    <AddEvent.Root contact={contact} item={item}>
                        <AddEvent.Trigger asChild>
                            <Button variant="transparent">Edit</Button>
                        </AddEvent.Trigger>
                    </AddEvent.Root>
                    <DeleteItem.Root itemId={item.id}>
                        <DeleteItem.Trigger asChild>
                            <Button variant="solid" color={'error'}>
                                Delete
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        </DeleteItem.Trigger>
                    </DeleteItem.Root>
                </div>
            </ActivityItem.Content>
        </ActivityItem.Root>
    );
};

export default ManualItem;
